// add
function addModules() {

    // start
    let tabs = [];
    
    // all
    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "supervisor",
        card: "card-1",
        icon: "check_circle",
        title: "Supervisor",
        description: "Review and approve claims.",
        notification: null,
        special: true,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "hod",
        card: "card-1",
        icon: "check_circle",
        title: "HOD",
        description: "Review and approve claims.",
        notification: null,
        special: true,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "compliance",
        card: "card-1",
        icon: "check_circle",
        title: "Compliance",
        description: "Approve claims. View invoices.",
        notification: null,
        special: true,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "finance",
        card: "card-1",
        icon: "account_balance",
        title: "Finance",
        description: "Pay claims. Confirm client payments.",
        notification: null,
        special: true,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "enrollee",
        card: "card-1",
        icon: "people",
        title: "Enrollees",
        description: "view active enrollees.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "auth",
        card: "card-2",
        icon: "insert_comment",
        title: "Pre-Authorizations",
        description: "Manage authorization requests.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "claim",
        card: "card-1",
        icon: "description",
        title: "Claims",
        description: "Manage claims.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "private",
        card: "card-2",
        icon: "business",
        title: "HMO Clients",
        description: "Manage (HMO) clients.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "public",
        card: "card-1",
        icon: "group_add",
        title: "Schemes",
        description: "Manage State Social Health Schemes.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "retail",
        card: "card-1",
        icon: "shopping_cart",
        title: "Retail Clients",
        description: "Manage (Retail) clients.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "tpa",
        card: "card-2",
        icon: "monetization_on",
        title: "TPA (Retainer) Clients",
        description: "Manage (TPA) clients.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "client",
        card: "card-2",
        icon: "business",
        title: "Clients",
        description: "View all clients from all categories.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "provider",
        card: "card-1",
        icon: "local_hospital",
        title: "Providers",
        description: "Manage all providers.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "tariffMini",
        card: "card-1",
        icon: "price_change",
        title: "Tariff Mini",
        description: "Review and adjust provider tariffs.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "hospital",
        card: "card-2",
        icon: "label",
        title: "Hospitals",
        description: "View primary care hospitals.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "report",
        card: "card-2",
        icon: "show_chart",
        title: "Insights",
        description: "View utilization.",
        notification: null,
        special: true,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "advisory",
        card: "card-2",
        icon: "work",
        title: "Advisory",
        description: "View upcoming invoices for all clients.",
        notification: null,
        special: true,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "adder",
        card: "card-2",
        icon: "add_circle",
        title: "Adders",
        description: "Add dependants to active principals.",
        notification: null,
        special: true,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "bypass",
        card: "card-1",
        icon: "file_upload",
        title: "Bypass",
        description: "Add enrollees to the monthly list - bypassing payment.",
        notification: null,
        special: true,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "settings",
        card: "card-1",
        icon: "settings",
        title: "Settings",
        description: "Manage plans, tariffs, users, others.",
        notification: null,
        special: true,
    });

    tabs.push({
        type: "hmo",
        id: tabs.length + 1,
        to: "help",
        card: "card-2",
        icon: "help_outline",
        title: "Help",
        description: "Guides, tutorials, and version updates.",
        notification: null,
        special: true,
    });

    tabs.push({
        type: "provider",
        id: tabs.length + 1,
        to: "encounter",
        card: "card-2",
        icon: "insert_comment",
        title: "Encounters",
        description: "Manage enrollee visits.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "provider",
        id: tabs.length + 1,
        to: "billing",
        card: "card-2",
        icon: "description",
        title: "Billings",
        description: "Manage claims.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "provider",
        id: tabs.length + 1,
        to: "list",
        card: "card-1",
        icon: "people",
        title: "Lists",
        description: "view active enrollees.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "provider",
        id: tabs.length + 1,
        to: "users",
        card: "card-2",
        icon: "account_box",
        title: "User Profiles",
        description: "View profile credentials.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "provider",
        id: tabs.length + 1,
        to: "help",
        card: "card-2",
        icon: "help_outline",
        title: "Help",
        description: "Guides, tutorials, and version updates.",
        notification: null,
        special: true,
    });

    tabs.push({
        type: "client",
        id: tabs.length + 1,
        to: "members",
        card: "card-1",
        icon: "people",
        title: "Members",
        description: "View all members.",
        notification: null,
        special: false,
    });
    
    tabs.push({
        type: "client",
        id: tabs.length + 1,
        to: "invoices",
        card: "card-1",
        icon: "receipt",
        title: "Invoices",
        description: "View all invoices.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "client",
        id: tabs.length + 1,
        to: "contract",
        card: "card-1",
        icon: "description",
        title: "Contract",
        description: "View HMO Contract.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "client",
        id: tabs.length + 1,
        to: "healthcare",
        card: "card-2",
        icon: "label",
        title: "Healthcare Facilities",
        description: "View primary care hospitals.",
        notification: null,
        special: false,
    });

     tabs.push({
        type: "client",
        id: tabs.length + 1,
        to: "profiles",
        card: "card-2",
        icon: "account_box",
        title: "Profiles",
        description: "View profile credentials.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "client",
        id: tabs.length + 1,
        to: "help",
        card: "card-2",
        icon: "help_outline",
        title: "Help",
        description: "Guides, tutorials, and version updates.",
        notification: null,
        special: true,
    });

    tabs.push({
        type: "principal",
        id: tabs.length + 1,
        to: "medical",
        card: "card-2",
        icon: "label",
        title: "Medical Facilities",
        description: "View available hospitals.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "principal",
        id: tabs.length + 1,
        to: "history",
        card: "card-2",
        icon: "insert_comment",
        title: "Medical History",
        description: "View hospital treatments.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "principal",
        id: tabs.length + 1,
        to: "benefits",
        card: "card-2",
        icon: "health_and_safety",
        title: "Benefits",
        description: "View plan benefits.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "principal",
        id: tabs.length + 1,
        to: "profile",
        card: "card-2",
        icon: "person",
        title: "Profile",
        description: "View Profile.",
        notification: null,
        special: false,
    });

    tabs.push({
        type: "principal",
        id: tabs.length + 1,
        to: "help",
        card: "card-2",
        icon: "help_outline",
        title: "Help",
        description: "Guides, tutorials, and version updates.",
        notification: null,
        special: true,
    });

    // return
    return tabs;
}

export {
    addModules,
}
